import React, { useState } from "react";
import { Link } from "react-router-dom";
import { loginUser } from "../../../services/auth-service/authService";
import ForgotPasswordPopup from "../forgot-password-popup/ForgotPasswordPopup";

interface LoginFormProps {
  regPage: string;
  handleSubmit: (e: React.FormEvent<HTMLFormElement>, formDdata: any) => void;
}

function LoginForm({ regPage, handleSubmit }: LoginFormProps) {
  let [formDdata, setFormDdata] = useState<any>({
    email: "",
    password: "",
  });
  const [showForgotPassword, setShowForgotPassword] = useState(false);

  const handleFormFieldChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    formField: string
  ) => {
    setFormDdata((prev: any) => {
      return { ...prev, [formField]: e.target.value };
    });
  };

  return (
    <div>
      <form onSubmit={(e) => handleSubmit(e, formDdata)}>
        <div className="row mb-2">
          <div className="col">
            <div className="form-floating mb-3">
              <input
                type="email"
                className="form-control"
                id="floatingInput"
                placeholder="name@example.com"
                value={formDdata.email}
                onChange={(e) => handleFormFieldChange(e, "email")}
              />
              <label htmlFor="floatingInput">Email address</label>
            </div>
            {/* <input
              type="email"
              className="form-control"
              placeholder="Enter Email"
              value={formDdata.email}
              onChange={(e) => handleFormFieldChange(e, "email")}
            /> */}
          </div>
        </div>
        <div className="row mb-2">
          <div className="col">
            <div className="form-floating">
              <input
                type="password"
                className="form-control"
                id="floatingPassword"
                placeholder="Password"
                value={formDdata.password}
                onChange={(e) => handleFormFieldChange(e, "password")}
              />
              <label htmlFor="floatingPassword">Password</label>
            </div>
            {/* <input
              type="password"
              className="form-control"
              placeholder="Enter Password"
              value={formDdata.password}
              onChange={(e) => handleFormFieldChange(e, "password")}
            /> */}
          </div>
        </div>
        <div className="row">
          <div className="col text-end">
            <div className="mt-2">
              <span
                className="text-primary cursor-pointer"
                style={{ cursor: "pointer" }}
                onClick={() => setShowForgotPassword(true)}
              >
                Forgot password ?
              </span>
            </div>
          </div>
        </div>
        <div className="mt-3">
          <button type="submit" className="btn btn-danger w-100 fw-bold py-2">
            Sign In
          </button>
          <p className="text-center div-link-no-decoration mt-3" style={{ fontSize: "0.875rem", color: "#64748b" }}>
            Not a member?{" "}
            <Link to={regPage} style={{ color: "#ed1b24", fontWeight: 600 }}>
              Create an account
            </Link>
          </p>
        </div>
      </form>
      {showForgotPassword && (
        <ForgotPasswordPopup onClose={() => setShowForgotPassword(false)} />
      )}
    </div>
  );
}

export default LoginForm;
